import { render, staticRenderFns } from "./DirectLinks.vue?vue&type=template&id=18959aff&scoped=true"
import script from "./DirectLinks.vue?vue&type=script&lang=js"
export * from "./DirectLinks.vue?vue&type=script&lang=js"
import style0 from "./DirectLinks.vue?vue&type=style&index=0&id=18959aff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18959aff",
  null
  
)

export default component.exports